/** @jsx jsx */
import { css } from "@emotion/react";

export const footerSection = css`
  padding: 80px 0px;
  background: #00854E;
  overflow: hidden;
  font-family: "normalidad-variable", sans-serif;
  .sobre{
    font-size: 22px;
  }
  img {
    /* margin-bottom: 16px; */
  }
  h4 {
    font-weight: 700;
    font-size: 24px;
    line-height: 120%;
    color: #EFEFEF;
    font-variation-settings: "wght" 130, "wght" 700;
    text-align: center;
    max-height: 42px;
    padding-top: 9px;
    justify-content: start;
    display: flex;
    align-items: end;
  }
  p {
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: #EFEFEF;
    margin-bottom: 0px;
  }
  .segments{
    
    font-weight: 400;
    font-size: 12px;
    font-family: 'Montserrat', sans-serif;
    color: #EFEFEF;
    text-decoration: none;
    position: relative;
  

    ::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -2px;  
      width: 0;
      height: 1px;  
      background-color: #EFEFEF;  
      transition: width 0.5s ease-in-out;
    }
  
    :hover::after {
      width: 100%;
    }
  }
  @media (max-width: 992px){
    display: none;
  }
  @media (min-width: 320px) and (max-width: 767px) {
   h4{
    justify-content: center;
    margin-top: 25px;
   }
  
  }
   @media (min-width: 768px) and (max-width: 990px) {
    margin: 0px;
    h4{
      justify-content: start;
      font-size: 20px;
      padding-top: 5px;
    }
    
   }
`
export const itens = css`
  .unitsLinks{
    font-weight: 400;
    font-size: 12px;
    font-family: 'Montserrat', sans-serif;
    color: #4BE66A;
    text-decoration: none;
    position: relative;
  

    ::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -2px;  
      width: 0;
      height: 1px;  
      background-color: #4BE66A;  
      transition: width 0.5s ease-in-out;
    }
  
    :hover::after {
      width: 100%;
    }
  }

  img{
    width: 30px;
    height: 30px;
    margin-right: 5px;
    filter: brightness(0) saturate(100%) invert(94%) sepia(27%) saturate(1948%) hue-rotate(56deg) brightness(105%) contrast(80%);
  }
  @media (min-width: 320px) and (max-width: 767px) {
    padding-top: 3px;
   a{ 
    text-align: center;
    display: block;
    line-height: 15px;
    font-size: 15px;
   }
 
  }

  @media (min-width: 481px) and (max-width: 767px) {
    padding-top: 3px;
    a{ 
    text-align: center;
    display: block;
    line-height: 15px;
    font-size: 15px;
   }
  
  }

   @media (min-width: 768px) and (max-width: 990px) {
    padding-top: 10px;
    a{ 
    text-align: justify;
    line-height: 0px;
    display: block;
    font-size: 11.5px;
   }
   
}
`
export const logoFooter = css`
  @media (min-width: 320px) and (max-width: 767px) {
    text-align: center;
    img{
      padding-bottom: 20px;
    }
   p{
    font-size: 14px;
    line-height: 15px;
   }
  }

  @media (min-width: 481px) and (max-width: 767px) {
    text-align: center;
    img{
      padding-bottom: 20px;
    }
    p{
    font-size: 14px;
    line-height: 5px;
   }
  }

   @media (min-width: 768px) and (max-width: 990px) {
    text-align: left;
    margin-right: 30px;
    img{
      width: 180px;
    }
  }
`

export const social = css`
  display: flex;
  flex-direction: column;
  .iconsSocial{
    display: flex;
    justify-Content: flex-start;
    align-Items:center;
  }
  .iconInsta{
      margin-left: 0px;
    }

  
  @media (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    padding-left: 0px;
    h4 {
    margin-right: 0px;
    }
    img {
      margin-left: 15px;
      width: 40px;
    }
  }

  @media (min-width: 481px) and (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    padding-left: 0px;
    h4 {
    margin-right: 0px;
    }
    img {
      margin-left: 15px;
      width: 40px;
    }
  }

   @media (min-width: 768px) and (max-width: 990px) {
    flex-direction: column;
    align-items: center;
    h4 {
    margin-right: 0px;
    }
    img {
      margin-right: 10px;
    }
  }
`
export const actionsImgIconsSocialFooter = css`
img{
  transition: filter 0.3s ease-out;
  filter: brightness(0) saturate(100%) invert(94%) sepia(27%) saturate(1948%) hue-rotate(56deg) brightness(105%) contrast(80%);
}
:hover {
  color: #F7FF53;
  img {
    filter: brightness(0) saturate(100%) invert(99%) sepia(63%) saturate(1577%) hue-rotate(16deg) brightness(116%) contrast(114%);
  }
}
:active {
  color: #4BE66A;
  img {
    filter: brightness(0) saturate(100%) invert(94%) sepia(27%) saturate(1948%) hue-rotate(56deg) brightness(105%) contrast(80%);
  }
}
`

export const mobileFooter = css`
  background: #00854E;
  overflow: hidden;
  font-family: "normalidad-variable", sans-serif;

h5{
  color:  #EFEFEF;
  font-size: 23px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; 
}

a{
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 150%;
  color: #EFEFEF;
  margin-bottom: 3px;
}

p{
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 150%;
  color: #EFEFEF;
  margin-bottom: 0px;
}

.unitsLinksMobile{
    font-weight: 400;
    font-size: 18px;
    font-family: 'Montserrat', sans-serif;
    color: #4BE66A;
    text-decoration: none;
    position: relative;
    margin-bottom: 0px;
    ::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -2px;  
      width: 0;
      height: 1px;  
      background-color: #4BE66A;  
      transition: width 0.5s ease-in-out;
    }
    :hover::after {
      width: 100%;
    }
  }

.imgUnitsmonile{
  width: 30px;
  height: 30px;
  margin-right: 5px;
  filter: brightness(0) saturate(100%) invert(94%) sepia(27%) saturate(1948%) hue-rotate(56deg) brightness(105%) contrast(80%);
}

@media (min-width: 992px){
  display: none;
}
`